import React from 'react';
import PropTypes from 'prop-types';
import {styled} from '@mui/material/styles';
import {Box, Skeleton, Stack, Typography} from '@mui/material';
import {isListAvailable, numberInUSFormat} from 'mui-core/utils';

const IconWrapper = styled(Box)(({theme}) => ({
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '35px',
  justifyContent: 'center',
  // background: 'linear-gradient(#6DDCFF, #7F60F9)',
  [`& div`]: {
    p: '8px',
    width: '38px',
    height: '38px',
    display: 'flex',
    borderRadius: '35px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--mui-palette-lightViolet-light)',
    ...theme.applyStyles('dark', {
      backgroundColor: 'var(--mui-palette-lightViolet-main)',
    }),
  },
}));

const StatsWithIcon = ({data = [], minWidth = 240, request = false}) => {
  const formatCount = count => {
    if (count === 0) {
      return '0';
    }
    try {
      return numberInUSFormat(count, {minimumIntegerDigits: 2});
    } catch (err) {
      return 0;
    }
  };

  return (
    <Stack
      direction="row"
      sx={{
        gap: 3,
        flexGrow: 1,
        flexWrap: 'wrap',
        margin: '24px 0px',
      }}>
      {request ? (
        <Stack direction="row" width="100%" gap={3} flexWrap="wrap">
          {Array.from({length: isListAvailable(data) && data?.length}).map(
            (_, i) => (
              <Skeleton
                key={i}
                height="97px"
                width={minWidth}
                variant="rectangular"
                sx={{borderRadius: '20px'}}
              />
            )
          )}
        </Stack>
      ) : (
        isListAvailable(data) &&
        data.map(({title = '', count = '0', icon}, index) => (
          <Stack
            key={index}
            spacing={2}
            direction="row"
            minWidth={minWidth}
            px={{xs: 1.5, md: 2}}
            py={{xs: 1.8, md: 2.5}}
            alignItems="flex-start"
            sx={[
              theme => ({
                borderRadius: 5,
                backgroundColor: 'var(--mui-palette-background-paper)',
                ...theme.applyStyles('dark', {
                  backgroundColor: 'var(--mui-palette-background-dark)',
                }),
              }),
            ]}>
            <IconWrapper>
              <div>{icon}</div>
            </IconWrapper>
            <Stack gap={0.5} sx={{minWidth: 60}}>
              <Typography
                variant="text-md-bold"
                sx={{
                  overflow: 'hidden',
                  color: 'text.primary',
                  display: '-webkit-box',
                  textOverflow: 'ellipsis',
                  ' -webkit-line-clamp': 2,
                  '-webkit-box-orient': 'vertical',
                }}>
                {title}
              </Typography>
              <Typography
                component="h4"
                variant="title-lg-thin"
                sx={{
                  lineHeight: 1,
                  color: 'text.primary',
                }}>
                {formatCount(count)}
              </Typography>
            </Stack>
          </Stack>
        ))
      )}
    </Stack>
  );
};

StatsWithIcon.propTypes = {
  data: PropTypes.array,
};

export default React.memo(StatsWithIcon);
